import React, { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import nexarLogo from "../../../../core/assets/nexar-n.png";
import { useTranslation } from "react-i18next";

import Event from "../../../../core/consts/analytics-events";
import Button from "../../../../components/button/button";
import styles from "./welcome.module.scss";
import { useDI } from "../../../../core/di";

interface Props {
  subtitle?: ReactNode;
}
export function Welcome(props: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { analytics } = useDI();

  useEffect(() => {
    analytics?.track(Event.WelcomeViewed);
  }, []);

  const handleNavigation = () => {
    analytics?.track(Event.WelcomeLoginClicked);
    navigate(`/login?redirect=${location.pathname}`);
  };

  return (
    <div className={styles.WelcomeWrapper}>
      <img className={styles.logo} src={nexarLogo} height="18px" alt="nexar-logo" />
      <h1 data-testid={"welcome-title"}>{t("welcomeToMyNexar")}</h1>
      {props.subtitle && <p>{props.subtitle}</p>}
      <footer>
        <Button action={handleNavigation} data-testid={"login-button"}>
          {t("login")}
        </Button>
      </footer>
    </div>
  );
}

export default Welcome;
